import React, { useState, useRef } from 'react';

const QuestionAccordion = ({ question, children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const contentRef = useRef(null);

	return (
		<div className={`c-question-accordion ${isOpen ? 'active' : ''}`}>
			<button className="c-question-accordion__btn" onClick={() => setIsOpen((prevValue) => !prevValue)}>
				<span className="c-question-accordion__circle"></span>
				{question}
			</button>
			<div
				className="c-question-accordion__content"
				aria-hidden={isOpen}
				ref={contentRef}
				style={{ maxHeight: contentRef.current ? contentRef.current.scrollHeight : '' }}
			>
				{children}
			</div>
		</div>
	);
};

export default QuestionAccordion;
